import Lottie from "lottie-react";

export default function Loader() {
  return (
    <div
      className={`w-screen h-svh flex justify-center items-center fixed backdrop-blur-sm top-0 right-0 z-50`}
    >
      <Lottie
        animationData={require("../assets/loadingLottie.json")}
        loop={true}
        autoplay={true}
      />
    </div>
  );
}
